class ProductImageCarousel extends HTMLElement{
    constructor(){
        super();
    }

    connectedCallback(){
        const id = this.dataset.selector;
        const element = document.querySelector('#swiper-image-' + id);
        const config = {
                'dots': true,
                'loop': false,
                'arrows': true,
                'autoplay': false,
                'spaceBetween': 10,
                'breakpoints': {
                    320:{
                        'slidesPerView': 2,
                        'slidesPerGroup': 1
                    }
                },
                'pagination': {
                  el: '.swiper-'+id+'__pagination',
                  'clickable': true,
                },
            }

            new Swiper( '#swiper-image-'+id, config );
            element.classList.add('block-swiper__initialize');
    }
  }
  customElements.define( 'product-image-carousel',  ProductImageCarousel );
